type TurkishDirectAddToCartRules = {
  leadingTokens: readonly string[];
  trailingTokens: readonly string[];
  negativePattern: RegExp;
  cartTargets: readonly string[];
  cartVerbs: readonly string[];
  buyVerbs: readonly string[];
  compactBuyVerbs: readonly string[];
};

const FAST_INTENT_MAX_CHARS = 96;
const TURKISH_DIRECT_ADD_TO_CART_RULES: TurkishDirectAddToCartRules = {
  leadingTokens: [
    'bana',
    'beni',
    'bi',
    'bir',
    'bu',
    'bunu',
    'da',
    'de',
    'hemen',
    'lutfen',
    'su',
    'sunu',
    'urun',
    'urunu',
  ],
  trailingTokens: ['artik', 'da', 'de', 'lutfen', 'misin', 'misiniz', 'ya'],
  negativePattern:
    /\b(?:ekleyem|ekleyemed|eklenem|eklenm|satin aldiktan|satin aldim|iade|iptal|olmuyor|olmadi|olmedi|sorun|problem)\b/,
  cartTargets: ['sepete', 'sepetime'],
  cartVerbs: ['at', 'atar', 'atsana', 'ekle', 'ekler', 'eklesene'],
  buyVerbs: ['al', 'alir', 'alsana'],
  compactBuyVerbs: ['satinal', 'satinalsana'],
};

const DIRECT_CART_LEADING_TOKENS = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.leadingTokens);
const DIRECT_CART_TRAILING_TOKENS = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.trailingTokens);
const DIRECT_CART_TARGETS = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.cartTargets);
const DIRECT_CART_VERBS = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.cartVerbs);
const DIRECT_BUY_VERBS = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.buyVerbs);
const DIRECT_BUY_COMPACT = new Set<string>(TURKISH_DIRECT_ADD_TO_CART_RULES.compactBuyVerbs);

function normalizeFastIntentText(text: string): string {
  return text
    .toLocaleLowerCase('tr-TR')
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ı/g, 'i')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ü/g, 'u')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

function isTurkishDirectAddToCartIntent(text: string): boolean {
  if (!text.trim() || text.length > FAST_INTENT_MAX_CHARS || /[?？]/.test(text)) return false;

  const normalized = normalizeFastIntentText(text);
  if (!normalized || TURKISH_DIRECT_ADD_TO_CART_RULES.negativePattern.test(normalized)) return false;

  const tokens = normalized.split(' ');
  while (tokens.length > 0 && DIRECT_CART_LEADING_TOKENS.has(tokens[0]!)) tokens.shift();
  while (tokens.length > 0 && DIRECT_CART_TRAILING_TOKENS.has(tokens[tokens.length - 1]!)) tokens.pop();
  if (tokens.length === 1) return DIRECT_BUY_COMPACT.has(tokens[0]!);
  if (tokens.length !== 2) return false;

  if (DIRECT_CART_TARGETS.has(tokens[0]!) && DIRECT_CART_VERBS.has(tokens[1]!)) return true;
  return tokens[0] === 'satin' && DIRECT_BUY_VERBS.has(tokens[1]!);
}

export function detectFastIntent(text: string): string | null {
  if (isTurkishDirectAddToCartIntent(text)) {
    return 'directAddToCart';
  }
  return null;
}
